export default {
    it: {
        

        "faqhelp_firstname": "Nome",
        "faqhelp_firstname-field-not-ok": "Per favore inserisci il nome",

        "faqhelp_lastname": "Cognome",
        "faqhelp_lastname-field-not-ok": "Per favore inserisci il cognome",

        "faqhelp_email": "Email",
        "faqhelp_email-field-not-ok": "Per favore inserisci un indirizzo email valido",

        "faqhelp_phone_mobile": "Recapito telefonico",
        "faqhelp_phone_mobile-field-not-ok": "Per favore un recapito telefonico valido",


        "name-field-not-ok": "Per favore inserisci il nome",
        "name-field-not-ok-6": "Per favore inserisci nome/cognome o ragione sociale",
        "name": "Nome",
       
        "error_flux_code": "Codice errore invio flusso trasmissione",
        "error_flux_code-field-not-ok": "Per favore inserisci codice valido",
        "error_flux_code-placeholder": "Codice errore invio flusso trasmissioni",

        "surname": "Cognome",
        "surname-field-not-ok": "Per favore inserisci il cognome",
        "surname-field-not-ok-6": "Per favore inserisci nome/cognome o ragione sociale",

        
        "mobile": "Recapito telefonico",
        "mobile-field-not-ok": "Per favore un recapito telefonico mobile o fisso valido",
        
        "mobile-6": "Recapito telefonico (la compilazione è fortemente consigliata per la lavorazione della richiesta)",
        "mobile-field-not-ok": "Per favore un recapito telefonico mobile o fisso valido",
        
        "telefon": "Recapito telefonico fisso",
        "telefon-field-not-ok": "Per favore un recapito telefonico mobile o fisso valido",
        
        "telephone": "Recapito telefonico",
        "telephone-field-not-ok": "Per favore un recapito telefonico valido",

        "pec":  "Indirizzo PEC",
        "pec-field-not-ok": "Per favore inserisci un indirizzo email PEC valido",
        "pec-placeholder": "Indirizzo pec",

        "email": "Indirizzo e-mail",
        "email-field-not-ok": "Per favore inserisci un indirizzo email valido",
        "email-placeholder": "La tua email dove potrai ricevere risposta",


        "piva": "Partita IVA",
        "piva-field-not-ok": "Per favore inserisci la tua partita iva o il tuo codice fiscale",
        "piva-field-not-ok-number": "La partita IVA deve essere un numero",
        //"piva-placeholder": "000000000000",

        "birthplace": "Luogo di nascita",
        "birthplace-field-not-ok": "Per favore inserisci il luogo di nascita",
        "birthplace-placeholder": "Luogo di nascita",

        "protocol_pec": "Protocollo della comunicazione PEC.",
        "protocol_pec-field-not-ok": "Per favore inserisci una PEC valida",
        "protocol_pec-placeholder": "Protocollo della comunicazione PEC.",

        "codfisc": "Codice Fiscale",
        "codfisc-field-not-ok": "Per favore inserisci il tuo codice fiscale o la tua partita iva",
        //"codfisc-placeholder": "XXXXXX00X00X000X",

        "pec_or_peo_email": "Selezionare la tipologia di casella email su cui si intende ricevere le comunicazioni di OAM",

        "idcode": "Codice ID del soggetto iscritto agli Elenchi e/o Registri OAM",
        "idcode-field-not-ok": "Per favore inserisci un codice ID valido",
        "idcode-placeholder": "Inserisci il tuo id code",


        "form-field-ok": "Ok!",
       
       
        "submit-request": "Invia richiesta",
        "terms-and-conditions": "Autorizzo il trattamento dei miei dati personali ai sensi del D.Lgs. 196/2003 e all’art. 13 GDPR 679/16.",
        "terms-and-conditions-not-ok": "Devi accettare prima di procedere",
        "privacy": "Consenso per la ",

        "iban": "IBAN sul quale si desidera ricevere il rimborso",
        "iban-field-not-ok": "Per favore inserisci un iban valido",
        "iban-placeholder": "",

        "ragione_sociale": "Ragione sociale",
        "ragione_sociale-field-not-ok": "Per favore inserisci una ragione sociale",
        "ragione_sociale-field-not-ok-6": "Per favore inserisci nome/cognome o ragione sociale",
        "ragione_sociale-placeholder": "",

        "intestatario": "Intestatario del conto",
        "intestatario-field-not-ok": "Per favore inserisci un intestatario",
        "intestatario-placeholder": "",

        "bic_swift": "Bic/Swift (in caso di iban stranieri)",
        "bic_swift-field-not-ok": "Per favore inserisci un codice bic/swift valido",
        "bic_swift-placeholder": "",

        
        "importo_richiesto": "Importo richiesto (€)",
        "importo_richiesto-field-not-ok": "Per favore inserisci un importo valido (numero maggiore di zero)",
        "importo_richiesto-placeholder": "",

        "importo_ricevuta": "Importo ricevuta (€)",
        "importo_ricevuta-field-not-ok": "Per favore inserisci un importo valido (numero maggiore di zero)",
        "importo_ricevuta-placeholder": "",
        
    },
    en: {

        "faqhelp_firstname": "Name",
        "faqhelp_firstname-field-not-ok": "Please choose a name",

        "faqhelp_lastname": "Surname",
        "faqhelp_lastname-field-not-ok": "Please choose a surname",

        "faqhelp_email": "Email",
        "faqhelp_email-field-not-ok": "Please a valid email",

        "faqhelp_phone_mobile": "Recapito telefonico",
        "faqhelp_phone_mobile-field-not-ok": "Please choose a valid phone number",

        "name": "Name",
        "name-field-not-ok": "Please choose a name",
        
        "area_preferenza": "Preference Area",
        "area_preferenza-field-not-ok": "Please choose a Preference Area",

        "surname": "Surname",
        "surname-field-not-ok": "Please choose a surname",

        "mobile": "Phone number",
        "mobile-field-not-ok": "Please choose a valid phone number",

        "telefon": "Phone number",
        "telefon-field-not-ok": "Please choose a valid phone number",

        "email": "Email",
        "email-field-not-ok": "Please a valid email",
        "email-placeholder": "Your email where you can receive a reply",

        "error_flux_code": "Transmission flow sending error code",
        "error_flux_code-field-not-ok": "Please enter a valid error code",
        "error_flux_code-placeholder": "Transmission flow sending error code",

        "piva": "VAT number",
        "piva-field-not-ok": "Please choose a valid VAT number",
        "piva-placeholder": "000000000000",

        "protocol_pec": "PEC communication protocol.",
        "protocol_pec-field-not-ok": "Please enter a valid PEC",
        "protocol_pec-placeholder": "PEC communication protocol",

        "pec":  "PEC address",
        "pec-field-not-ok": "Please enter a valid PEC address",
        "pec-placeholder": "PEC address",

        "codfisc": "Tax ID code",
        "codfisc-field-not-ok": "Please choose a valid Tax ID code",
        "codfisc-placeholder": "XXXXXX00X00X000X",

        "birthplace": "Birth place",
        "birthplace-field-not-ok": "Please enter your birth place",
        "birthplace-placeholder": "Birth place",

        "idcode": "ID code of the person registered in the OAM Lists and / or Registers",
        "idcode-field-not-ok": "Please choose a valid code id",
        "idcode-placeholder": "Enter your id code",

        "form-field-ok": "Ok!",
        
        "submit-request": "Submit request",
        "terms-and-conditions": "I authorize the processing of my personal data pursuant to Legislative Decree 196/2003 and to the article 13 GDPR 679/16.",
        "terms-and-conditions-not-ok": "You must agree before submitting",
        "privacy": "Consent for ",

        "iban": "IBAN",
        "iban-field-not-ok": "Please enter a valid IBAN",
        "iban-placeholder": "",
    
        "intestatario": "Account Holder",
        "intestatario-field-not-ok": "Please enter an account holder",
        "intestatario-placeholder": "",
    
        "bic_swift": "BIC/Swift",
        "bic_swift-field-not-ok": "Please enter a BIC/Swift code",
        "bic_swift-placeholder": "",

        "ragione_sociale": "Ragione sociale",
        "ragione_sociale-field-not-ok": "Per favore inserisci una ragione sociale",
        "ragione_sociale-placeholder": "",
   
    }
}